// Display metadata only: never use company/sector labels to match instruments.
export function importRowProfile(row, plan) {
  const planned = plan?.desired.find(item => item.id === row.id)
  const candidate = row.candidate || planned?.candidate
  const previous = row.previous || planned?.previous
  const name = row.companyName || candidate?.companyName || candidate?.description || previous?.displayName || row.displayName || ''
  return {
    companyName: name && name !== row.symbol ? name : '',
    sector: row.sector || candidate?.sector || '',
    category: row.category || candidate?.category || '',
    subcategory: row.subcategory || candidate?.subcategory || '',
  }
}

export function importSectorSummary(rows, plan) {
  const seen = new Set(), counts = new Map()
  let unavailable = 0
  for (const row of rows) {
    if (['invalid', 'duplicate'].includes(row.status) || !row.symbol || seen.has(row.symbol)) continue
    seen.add(row.symbol)
    const { sector } = importRowProfile(row, plan)
    if (!sector) unavailable += 1
    else counts.set(sector, (counts.get(sector) || 0) + 1)
  }
  return {
    total: seen.size, unavailable,
    sectors: [...counts].map(([sector, count]) => ({ sector, count })).sort((a, b) => b.count - a.count || a.sector.localeCompare(b.sector)),
  }
}

// Metadata review is read-only. Missing profiles never become inferred labels.
export async function lookupImportProfiles({ rows, search, signal, onRow }) {
  for (const row of rows) {
    if (signal?.aborted) break
    if (['invalid', 'duplicate'].includes(row.status)) continue
    try {
      const response = await search(row.symbol, { signal })
      if (signal?.aborted) break
      const matches = (response.results || []).filter(candidate => candidate.symbol === row.symbol
        && candidate.secType === 'STK' && candidate.exchange === 'SMART' && candidate.currency === 'USD')
      if (matches.length === 1) onRow({ ...row, ...importRowProfile({ ...row, candidate: matches[0] }) })
    } catch { /* Optional display metadata can be unavailable; saving still verifies identity. */ }
  }
}
